import _typeof from "@babel/runtime/helpers/typeof";
import { isRPCRequest, isRPCResponse } from '../rpc/bridge-api-rpc-message';

/**
 * The message envelope actually exchanged between bridge API clients at a low-level between transports.
 *
 * @description Can be used for logging and filtering purposes. E.g., to filter out events from the current
 * window to itself or irrelevant to the current window in the browser implementation.
 */

/**
 * Validates an incoming message as being from a bridge API client.
 *
 * @description NOTE: {@link window.postMessage} is often used by Chrome extensions and frontend libraries for communication.
 * Hence, it is important to ensure any message we receive via {@link window.postMessage} is validated.
 *
 * @param envelope raw envelope sent over the transport to the current JS context
 */
export var isTransportEnvelope = function isTransportEnvelope(envelope) {
  return Boolean(envelope && typeof envelope.version === 'number' && typeof envelope.source === 'string' && envelope.message && _typeof(envelope.message) === 'object' && (isRPCRequest(envelope.message) || isRPCResponse(envelope.message)));
};